var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('NavBar'),_c('Banner'),_c('MainMessage'),_c('Menu'),_c('Carousel'),_c('Location'),_c('EmployeeRecruitment'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }